(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["auto-image-carousel"] && !Shopify.designMode) return;
  try {
    
  // Alpine.js + Embla Carousel 初期化
  document.addEventListener('alpine:init', () => {
    Alpine.data('emblaSlider', (options = {}) => ({
      embla: null,
      autoplay: options.autoplay ?? true,
      loop: options.loop ?? true,
      fade: options.fade ?? false,
      init() {
        this.embla = EmblaCarousel(this.$refs.emblaViewport, {
          loop: this.loop,
          align: 'start',
          containScroll: 'trimSnaps',
        });

        // 自動スクロール設定
        if (this.autoplay) {
          const autoplay = () => {
            if (!this.embla.canScrollNext()) {
              this.embla.scrollTo(0);
            } else {
              this.embla.scrollNext();
            }
          };
          setInterval(autoplay, 3500);
        }
      }
    }));
  });

  } catch(e) { console.error(e); }
})();
})();
